<div class="root-body"
     [ngClass]="{
    'root-body-sidebar-slim': configService.config.menuMode === 'sidebar' || configService.config.menuMode === 'slim',
    'root-body-sidebar-static': configService.config.menuMode === 'sidebar' && configService.config.sidebarStatic,
    'root-body-horizontal': configService.config.menuMode === 'horizontal'}">

    <p-breadcrumb class="breadcrumb mb-3" [model]="breadcrumbs"></p-breadcrumb>

    <div class="card">
        <!-- Table -->
        <p-table [columns]="cols"
                 [value]="todas"
                 [lazy]="true"
                 responsiveLayout="auto"
                 dataKey="TODAID"
                 (onLazyLoad)="handleLazyLoad($event)"
                 [loading]="loading"
                 (selectionChange)="onSelectionChange($event)"
                 [showFirstLastIcon]="false"
                 [paginator]="true"
                 [(first)]="first"
                 [rows]="rowsPerPage"
                 [rowsPerPageOptions]="rowsPerPageOptions"
                 [totalRecords]="totalRecords"
                 [resizableColumns]="true"
                 [columnResizeMode]="'expand'"
                 [styleClass]="'p-datatable-gridlines'"
                 [scrollable]="true"
                 [autoLayout]="true"
                 [scrollHeight]="'flex'">
            <ng-template pTemplate="caption">
                <div class="flex justify-content-between">
                    <div class="title-float-left">
                        <div class="onboarding-head-title">
                            TODAs
                        </div>
                    </div>
                    <div class="flex title-float-right">
                        <span class="filters-panel-item">
                            <button style="width: 90px;" pButton pRipple type="button" label="Filter"
                                    class="filters-panel-item-button p-button-outlined p-button-secondary"
                                    (click)="openFilter()"></button>
                        </span>
                        <span class="filters-panel-item p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text" class="search-input"
                               [(ngModel)]="filter.searchName"
                               style="width: 280px;"
                               placeholder="Search here..." />
                        </span>
                        <div class="ml-3 mt-3 mr-2">
                            <column-selector #columnSelector
                                 [defaultColumns]="defaultCols"
                                 (selectedColumnsChange)="onSelectedColumnsChange($event)"
                                 [tableName]="tableName"
                                 [(selectedColumns)]="cols">
                            </column-selector>
                        </div>
                    </div>
                </div>
                <div class="flex flex-row sp-header"></div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th *ngFor="let col of cols"
                        [pSortableColumn]="col.field"
                        [pSortableColumnDisabled]="col.disableSort"
                        pResizableColumn
                        [style.width]="col.width">
                        {{col.header}}
                        <p-sortIcon class="onboarding-column-sorticon" *ngIf="col.showSortIcon"
                                    [field]="col.field"></p-sortIcon>
                    </th>
                </tr>
                <tr>
                    <ng-container *ngFor="let filter of this.cols">
                        <th class="overflow-unset">
                            <ng-container *ngIf="filter.fieldType === fieldTypeEnum.Inputs">
                                <input type="text" pInputText placeholder="{{filter.placeholder}}" [(ngModel)]="todaHeaderSearch[filter.model]"
                                       (input)="handleFilterChange(filter.field, $event)" />
                            </ng-container>
                            <ng-container *ngIf="filter.fieldType === fieldTypeEnum.Dropdown">
                                <p-dropdown [options]="filter.options" placeholder="{{filter.placeholder}}"
                                            optionLabel="name" optionValue="value" [(ngModel)]="todaHeaderSearch[filter.model]"
                                            (ngModelChange)="onChangeHeaderFilterDropDown(filter.field, $event)"></p-dropdown>
                            </ng-container>
                        </th>
                    </ng-container>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-toda>
                <tr>
                    <td *ngFor="let col of cols" [pSelectableRow]="toda" class="ui-resizable-column">
                        <ng-container [ngSwitch]="col.field">

                            <ng-container *ngSwitchCase="'Id'" class="ui-resizable-column">
                                XBT-{{toda.Id}}AA
                            </ng-container>

                            <ng-container *ngSwitchDefault>{{toda[col.field]}}</ng-container>

                            <ng-container *ngSwitchCase="'RiderServiceTypeDisplayText'" class="ui-resizable-column">
                                {{toda.RiderServiceTypeDisplayText}}
                            </ng-container>

                            <ng-container *ngSwitchCase="'RiderServiceTypeDisplayText'" class="ui-resizable-column">
                                {{toda.LastActiveDisplayText}}
                            </ng-container>

                            <ng-container *ngSwitchCase="'StatusDisplayText'" class="ui-resizable-column">
                                <span class="onbg-status-col" [ngStyle]="getStatusStyles(toda.TodaActivityStatus)">
                                    {{toda.StatusDisplayText}}
                                </span>
                            </ng-container>
                        </ng-container>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                  <td colspan="100%">
                    <div class="flex flex-column align-items-center justify-content-center py-6">
                      <img
                        src="/XpressApp/assets/images/commerce/no-product.png"
                        alt="No data"
                        class="w-40 h-40 mb-3 opacity-70"
                      />
                      <span class="text-gray-500 text-md">There are no existing TODAs.</span>
                    </div>
                  </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="paginatorleft" let-state>
                <div *ngIf="firstColumnTODAs.Items.length > 0" style="padding-left: 10px">
                    Showing {{first + 1}} to {{first + firstColumnTODAs.Items.length}} of {{totalRecords}} entries
                </div>
            </ng-template>
        </p-table>
    </div>
</div>
<p-toast position="top-right"></p-toast>
